import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import FridayService from '@services/friday';
import NativeInterface from '@helpers/NativeInterface';
import { commandMessage, isCubeApp } from '@helpers/Constants';

import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';

interface IProps {
  onClose?: () => void;
}

const Success = (props: IProps) => {
  const goBack = () => {
    props.onClose && props.onClose();
  };

  const confirm = async () => {
    if(isCubeApp()) {
      NativeInterface.postMessage(commandMessage.commandLogout, {
        requestRemote: false
      });
    }
    const isMiniProgram = window?.__wxjs_environment === 'miniprogram';
    if(isMiniProgram) { //如果是在小程序环境中 需要向小程序postMessage, 返回当前页面
      window.wx.miniProgram.navigateBack();
      window.wx.miniProgram.postMessage({
        data: {
          status: 1
        },
        success: function(suc: unknown) {
          // eslint-disable-next-line no-console
          console.log('postMessage suc', suc);
        },
        fail: function(err: unknown) {
          // eslint-disable-next-line no-console
          console.log('postMessage fail', err);
        },
      });
    }
  }

  useEffect(() => {
    FridayService.addEvent('account_cancellation_logout_success_page_page_itself_display');
  }, [])

  return ReactDOM.createPortal(
    <div styleName="success">
      <NavBar title="注销成功" onClickBackBtn={ goBack } hideBackButton={window?.__wxjs_environment === 'miniprogram'} />
      <div  className="flex" styleName="tip">
        <i className="iconfont icon-chenggong" />
        <span styleName="tip-title">注销成功</span>
        <span styleName="tip-desc">已抹除该帐号全部数据</span>
      </div>
      <CommonBtn type="fixed" btnText="返回登录页" onConfirm={ confirm } />
    </div>,
    document.getElementById('modal') as HTMLDivElement
  )
}

export default Success;